var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indexbox"},[_c('nav-bar',{attrs:{"left-arrow":"","title":_vm.$t('语音聊天')}}),(!_vm.chaturl)?_c('van-skeleton',{attrs:{"title":"","avatar":"","row":5}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }